import React from 'react';
import PropTypes from 'prop-types';

const HeaderSecondary = (props) => (
    <React.Fragment>
        { /* START H1 Header */}
        <div className={` d-flex ${ props.className }` }>
            <h2 className="display-6 mr-3 mb-0 align-self-start">
                { props.title }
            </h2>
        </div>
        { /* END H1 Header */}
    </React.Fragment>
)
HeaderSecondary.propTypes = {
    title: PropTypes.string,
    subTitle: PropTypes.node,
    className: PropTypes.string
};
HeaderSecondary.defaultProps = {
    title: "Waiting for Data...",
    subTitle: "Waiting for Data...",
    className: "my-1"
};

export { HeaderSecondary };
